import {createReduxStore, register, subscribe} from '@wordpress/data';

import {STORE_KEY} from "./constants";
import * as actions from './actions';
import reducer from './reducers';
import * as selectors from './selectors';

const config = {
    reducer,
    selectors,
    actions
}

export {
    STORE_KEY
};

export const store = createReduxStore(STORE_KEY, config);

register(store);